export const COMMENTARY_FIELD_KEY_PREFIX = 'commentary:';
export const RECONCILIATION_FIELD_KEY_PREFIX = 'reconciliation:';

export const toCommentaryTargetCellKey = (fieldName: string) =>
  `${COMMENTARY_FIELD_KEY_PREFIX}${fieldName}`;

export const toReconciliationTargetCellKey = (fieldName: string) =>
  `${RECONCILIATION_FIELD_KEY_PREFIX}${fieldName}`;

export const toRequiredFieldTargetCellKey = (
  page: 'appraisify-commentary' | 'reconciliation',
  fieldName: string,
) =>
  page === 'appraisify-commentary'
    ? toCommentaryTargetCellKey(fieldName)
    : toReconciliationTargetCellKey(fieldName);

export const parseRequiredFieldTargetCellKey = (targetCellKey: string) => {
  if (targetCellKey.startsWith(COMMENTARY_FIELD_KEY_PREFIX)) {
    return {
      page: 'appraisify-commentary' as const,
      fieldName: targetCellKey.slice(COMMENTARY_FIELD_KEY_PREFIX.length),
    };
  }
  if (targetCellKey.startsWith(RECONCILIATION_FIELD_KEY_PREFIX)) {
    return {
      page: 'reconciliation' as const,
      fieldName: targetCellKey.slice(RECONCILIATION_FIELD_KEY_PREFIX.length),
    };
  }
  return undefined;
};

export const scrollRequiredFieldIntoView = (fieldName: string) => {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      const container = document.querySelector(`[data-required-field="${fieldName}"]`);
      if (container instanceof HTMLElement) {
        container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });
};

export const focusRequiredField = (fieldName: string) => {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      const container = document.querySelector(`[data-required-field="${fieldName}"]`);
      if (!(container instanceof HTMLElement)) {
        return;
      }
      container.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const focusable = container.querySelector<HTMLElement>(
        'input, textarea, button, [role="combobox"]',
      );
      if (focusable) {
        focusable.focus();
        if (focusable.tagName === 'BUTTON') {
          focusable.click();
        }
        return;
      }
      container.focus();
    });
  });
};
